export const environment = {
  production: false,
  name: 'staging',
  encryptionKey: 'Tjcjavr2TPMiixGSUrbqySC7qagyY0IWlIrev4RZnvsEJPBjFoRsDpBmuD2WxxKL',
  encryptionIv: 'sbWIbGr25EOItOzCz2mlliu7ZEgRaPu7klKEEFELJjQ=',
  googleAuthUrl: 'https://purchase-api.petpooja.com/api/web/authentication/v1/auth/google',
  authentication: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/authentication/v1/'
  },
  dashboard: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/dashboard/v1/'
  },
  invoice: {
    bypassUrl: 'https://purchase-api.petpooja.com',
    bypassPath: '/api/web/invoice/v1/',
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/invoice/v1/',
    pathV2: '/api/web/invoice/v2/',
    bypassPathV2: '/api/web/invoice/v2/'
  },
  payment: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/payment/v1/',
    bypassUrl: 'https://purchase-api.petpooja.com',
    bypassPath: '/api/web/payment/v1/',
  },
  metadata: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/metadata/v1/'
  },
  pushtopetpooja: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/push-to-petpooja/v1/'
  },
  tally: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/tally/v1/'
  },
  sentry: {
    dsn: 'https://c65d926eaae8c8aab5f1ac6ee3975d10@o4506522915373056.ingest.us.sentry.io/4509717283536896', // Add your Sentry DSN here for staging
    environment: 'staging',
    tracesSampleRate: 0.3,
    enabled: true // Set to true when you have your DSN
  },
  hyperpureTrustedOrigin: 'https://www.hyperpure.com'
};